import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import { CardExpiryElement, injectStripe, CardNumberElement, CardCVCElement, PostalCodeElement } from 'react-stripe-elements';
import { Spinner, PrimaryButton, SpinnerSize } from '@fluentui/react';

class CheckOutForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: undefined,
            showError: false,
            updateProgress: false,
            showSuccess: false
        }
    }

    updateSub(f) {
        //var tmpFac = this.props.user;
        //tmpFac.products_facilities.map((obj) => {
        //    if (obj.FacilityId == f) {
        //        obj.TrialPeriodEnd = moment().subtract(1, 'months').toString();
        //    }
        //})
        //this.props.dispatch(updateUser(tmpFac));
        //localStorage.setItem("products_facilities", JSON.stringify(this.props.user.products_facilities));
    }

    createSubstription(result, facility) {
        if (result.token) {
            // Use the token to create a charge or a customer
            
            var params = {
                stripeToken: result.token.id,
                FacalityID: facility.facilityId,
                Slug: this.props.product + '-' + this.props.type.toLowerCase(),
                ProductSlug: this.props.product
            };
            this.setState({
                updateProgress: true
            });
            axios.post(AUTH_CONFIG.API_URL + "/api/Stripe/CreateSubscription", params)
                .then((response) => {
                    this.setState({
                        updateProgress: false,
                        showSuccess: true
                    });
                    this.updateSub(facility.facilityId);
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: "An error has occured, please try your payment again.",
                        showError: true
                    });
                });
        } else if (result.error) {
            this.setState({
                errorMessage: result.error.message,
                showError: true
            });
        }
    }

    handleSubmit = (ev) => {
        
        ev.preventDefault();
        this.setState({
            errorMessage: undefined,
            showError: false
        });

        if (this.props.stripe) {
            this.props.facilities.filter(x => x.checked == true).forEach((f, index) => {
                this.props.stripe
                    .createToken()
                    .then((payload) => this.createSubstription(payload, f));
            });
        } else {
            this.setState({
                errorMessage: "An error has occured, please contact MHSS for further assistance.",
                showError: true
            });
        }
    };
    render() {
        return (
            <form onSubmit={this.handleSubmit} className="default-form checkout-form">
                {this.state.showError &&
                    <div className="alert alert-danger" style={{ 'width': "500px", 'paddingLeft': '30px', marginBottom: '15px' }}>
                        <strong>Error:</strong> {this.state.errorMessage}
                    </div>
                }
                {this.state.showSuccess &&
                    <div className="alert alert-info" style={{ 'width': "500px", 'paddingLeft': '30px', marginBottom: '15px' }}>
                        <strong>Success!</strong> Your subscription payment was successful.
                    </div>
                }
                <label class="control-label">
                    Card number
          <CardNumberElement />
                </label>
                <label class="control-label">
                    Expiration date
          <CardExpiryElement />
                </label>
                <label class="control-label">
                    CVC
          <CardCVCElement />
                </label>
                <label class="control-label">
                    Postal code
          <PostalCodeElement />
                </label>
                <div className="displayflex mt30 aligncenter">
                    <PrimaryButton text={'Complete purchase'} type='submit' style={{ height: 40 }} />
                    {this.state.updateProgress &&
                        <div className="ml10"> <Spinner className="ml5" size={SpinnerSize.small} /></div>
                    }
                </div>
               
            </form>
        );
    }
}

const mapStateToProps = state => ({
    facilityId: state.appState.product.facility.facilityID
});

export default injectStripe(connect(mapStateToProps)(CheckOutForm));